import { User, LoginState, isLoggedInState } from "../components/portal/state";
import * as React from "react"
import * as i18next from 'i18next'
import { Action, AsyncState } from "widgets-for-react";
import { State, ExtraUserInfo } from "./portal_client";
import { ProductConfiguration, QuotationResponse } from "./portal/types";
import { stateZero } from "./portal_utils/state_zero";

export type QuotationStatusProps = {
  user: () => User<ExtraUserInfo>,
  setState: (_: Action<AsyncState<QuotationResponse>>) => void,
  state: LoginState<State, ExtraUserInfo>,
}

export class QuotationStatus extends React.Component<QuotationStatusProps>  {
  constructor(props: QuotationStatusProps, context: any) {
    super(props, context)
  }

  render() {
    let state = this.props.state
    let appState = this.props.state.appState
    return isLoggedInState(state) ?
      <>
        <section className="section section--request-submitted container container--m gutter--m">
          <div className="section__inner">
            <header className="section__header">
              <h1 className="section__title title--l">{i18next.t('quotation_request:submit.title_success.a')}<span> {i18next.t('quotation_request:submit.title_success.b')}</span></h1>
            </header>

            <p className="section__intro section__text">{i18next.t('quotation_request:submit.text_success')}</p>

            <div className="section__button">
              <button
                type="button"
                className="button button--primary"
                onClick={() => {
                  this.props.setState(s => {

                    if (isLoggedInState(state)) {
                      return({...s, appState: stateZero })

                    }
                  })
                  window.location.reload()
                 }}
              >
                {i18next.t('quotation_request:submit.clickables.create_new')}
              </button>
            </div>
          </div>
        </section>
        <article className="file-preview section container container--m gutter--m">
          <div className="file-preview__inner">
            <header className="file-preview__header">
              <h2 className="title--m">{i18next.t('quotation_request:submit.preview.title')}</h2>
            </header>
            <div className="file-preview__intro">
              <address>
                <p>{appState.quotation_request.project_name}</p>
                <p>{appState.quotation_request.project_address}</p>
                <p>{appState.quotation_request.project_city}</p>
                <p>{appState.quotation_request.project_country}</p>
              </address>
              <p>{i18next.t('quotation_request:submit.preview.title')}: <time dateTime={appState.quotation_request.required_delivery_date.year.toString() + "-" + appState.quotation_request.required_delivery_date.month.toString() + "-01"}>{appState.quotation_request.required_delivery_date.year.toString()}-{appState.quotation_request.required_delivery_date.month.toString()}</time></p>
            </div>
            <ul className="file-preview__list">        
                {appState.productConfigurations.toList().map(x => 
                  <li className="file-preview__item" key={x.ProductId}>
                    <QSProductDescription
                      key={x.ProductId}
                      product_name={appState.products.kind == "loaded" ? appState.products.value.find(y => y.Id == x.ProductId) ? appState.products.value.find(y => y.Id == x.ProductId).Name : "" : ""}
                      product_configuration={x}
                    />
                  </li>
                )}
            </ul>

          </div>
        </article>
      </>
      : <></>
   }

}

type QSProductDescriptionProps = {
  product_name: string,
  product_configuration: ProductConfiguration
}

const QSProductDescription: React.StatelessComponent<QSProductDescriptionProps> = ({ product_name, product_configuration }) => {
  let characteristics = product_configuration.CharacteristicArray
  if (characteristics.kind == "loaded") {
    let a_characteristics = characteristics.value

    return (<>
      <h3 className="text--l">{product_name}, {product_configuration.Count} {product_configuration.Count == 0 ? "piece" : "pieces" }</h3>
      <ul className="file-preview__details">
        {
          product_configuration.CharacteristicValues.map(x => {
            let characteristic = a_characteristics.find(value => value.Id == x.CharacteristicId);
            if (characteristic != null) {
              return <li key={characteristic.Id} >{characteristic.Text}: {characteristic.ValueOptions.length == 0 ? x.CharacteristicValueId : characteristic.ValueOptions.find(value => value.ValueId == x.CharacteristicValueId) ? characteristic.ValueOptions.find(value => value.ValueId == x.CharacteristicValueId).Value : ""}</li>
            }
          })
        }
      </ul>
    </>)
  }
  else {
    return <></>
  }
}

export const QuotationStatusElement =
  (
    user: () => User<ExtraUserInfo>,
    setState: (_: Action<AsyncState<QuotationResponse>>) => void,
    state: LoginState<State, ExtraUserInfo>
  ): JSX.Element => <QuotationStatus user={user} setState={setState} state={state} />